export default __webpack_public_path__ + "static/media/sparkpost.72f22396.svg";